<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaEmpresasInquilinas"
      :titulo="$t ('Empresas inquilinas')"
      icono="mdi-vector-square"
      tabla="empinq"
      :campos="['id_empinq-', 'nom+', 'id_ins', 'percon', 'corele', 'fecalt-', 'obs-', 'platot', '__listippas']"
      :campos-filtrables="['id_ins']"
      :objeto-definicion-campos="dc"
      :objeto-registro-formulario="rf"
      busqueda-rapida
      titulo-crud="empresa inquilina"
      campo-sujeto-accion="nom"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      @montado="montadoTablaDatos"
      :formulario-datos-api-props="{ anchoMaximo: '1250', sinMargenes: true }"
      :evento-antes-abrir-formulario-datos="antesAbrirFormularioDatos"
      :evento-antes-guardar-formulario-datos="antesGuardarFormularioDatos"
      :evento-despues-guardar-formulario-datos="despuesGuardarFormularioDatos"
      mensaje-confirmacion-al-eliminar="Al eliminar la empresa inquilina, se borrarán todos los registros dependientes en Operadores, Pases y Distribución de plazas.<br>¿Está seguro que desea continuar?"
    >
      <!-- C O L U M N A S   T A B L A -->

      <!-- <template v-slot:[`item.nom`]="{ item }">
        <img v-if="item.urllog" :src="item.urllog" style="max-height: 30px; width: auto; max-width: 150px; margin: 2px 0px -7px 0px" />
        <span v-else>{{ item.nom }}</span>
      </template> -->

      <!-- F O R M U L A R I O -->

      <template v-slot:default="{ definicionCampos, datosRegistro, esAccionEliminar }">
        <div style="min-height: 450px">
        <v-tabs v-model="tab" fixed-tabs background-color="#E0E0D0" mobile-breakpoint="0">
          <!-- <v-tabs-slider color="red"></v-tabs-slider> -->
          <v-tab>
            <v-icon class="mr-3">mdi-account-box</v-icon>{{ $t ('Datos') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-account-key</v-icon>{{ $t ('Operadores') }}
          </v-tab>
          <v-tab>
            <v-icon class="mr-3">mdi-format-list-text</v-icon>{{ $t ('Pases') }}
          </v-tab>
          <v-tab @change="forzarValidacionCampos">
            <v-icon class="mr-3">mdi-select-compare</v-icon>{{ $t ('Asignación de plazas') }}
          </v-tab>
          <v-tab v-if="$parametros_configuracion ['modres']">
            <v-icon class="mr-3">mdi-calendar-cursor</v-icon>{{ $t ('Reservas') }}
          </v-tab>
          <v-tab v-if="$parametros_configuracion ['modvaltic']">
            <v-icon class="mr-3">mdi-star-check</v-icon>{{ $t ('Validación de tickets') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" touchless>
          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row>
                <v-col cols="4" class="pb-0">
                  <CampoFormularioDatos nombre-campo="nom" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="3" class="pb-0">
                  <CampoFormularioDatos nombre-campo="nif" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="5" class="pb-0">
                  <CampoFormularioDatos nombre-campo="id_ins" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="actualizarListaTarifasValidacionTickets" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7" class="pb-0">
                  <CampoFormularioDatos nombre-campo="dom" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="5" class="pb-0">
                  <CampoFormularioDatos nombre-campo="pob" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" class="pb-0">
                  <CampoFormularioDatos nombre-campo="codpos" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="5" class="pb-0">
                  <CampoFormularioDatos nombre-campo="pro" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="4" class="pb-0">
                  <CampoFormularioDatos nombre-campo="pai" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-0">
                  <CampoFormularioDatos nombre-campo="percon" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <CampoFormularioDatos nombre-campo="corele" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pb-0">
                  <CampoFormularioDatos nombre-campo="tel1" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col cols="6" class="pb-0">
                  <CampoFormularioDatos nombre-campo="tel2" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="pb-0">
                  <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="8" class="pb-0">
                  <CampoFormularioDatos nombre-campo="urllog" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
                <v-col class="pb-0">
                  <center>
                    <img class="mb-3" v-if="datosRegistro.urllog" :src="datosRegistro.urllog" style="max-height: 90px; max-width: 270px; width: auto;" />
                  </center>
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <div class="mt-n3 mb-2">{{ $t ('Lista de operadores gestores') }}</div>
                 <TablaDatosAPI
                  ref="tablaOperadores"
                  icono="mdi-account-key"
                  tabla="v_opeempinq"
                  :campos="['corele', 'nom', 'fecalt', 'ultinises']"
                  :titulo-crud="$t ('operador')"
                  :parametros="parametros_opeempinq"
                  modo-memoria
                  dense
                  :permitir-anadir="!esAccionEliminar"
                  :permitir-modificar="!esAccionEliminar"
                  :permitir-eliminar="!esAccionEliminar"
                  @cambios="cambiosEnOperadores (datosRegistro)"
                  @montado="montadoTablaDatos"
                  >

                  <template v-slot:[`item.nom`]="{ item }">
                      {{ item.nom }}
                      <span v-if="item.blo != 0"><v-icon color="orange">mdi-lock</v-icon></span>
                  </template>
                </TablaDatosAPI>
            </v-container>
          </v-tab-item>

          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <CampoFormularioDatos nombre-campo="__listippas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
              <v-row class="mt-10">
                <v-col cols="12">
                  <CampoFormularioDatos nombre-campo="resestprepasdia" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <v-row>
                <v-col cols="3" class="pb-0">
                  <CampoFormularioDatos nombre-campo="platot" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <CampoFormularioDatos nombre-campo="__maxplazon" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :funcionFiltradoItems="filtradoItemsZonasSegunTiposDePases" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <CampoFormularioDatos nombre-campo="__asiplazon" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :funcionFiltradoItems="filtradoItemsZonasSegunTiposDePases" />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item v-if="$parametros_configuracion ['modres']" :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <div class="mb-4">Requisitos de solicitud de reservas:</div>
              <div class="ml-3">
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="reshorantmin" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="resdiaantmax" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                  <v-col cols="4" class="ml-4">
                    <CampoFormularioDatos nombre-campo="reshorantmax" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="reshordurmax" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                  <v-col cols="4" class="ml-4">
                    <CampoFormularioDatos nombre-campo="resmindiaent" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="resmaxporpas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                  <v-col cols="4" class="ml-4">
                    <CampoFormularioDatos nombre-campo="resminanuaut" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12">
                    <CampoFormularioDatos nombre-campo="rescerdesuso" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-tab-item>

          <v-tab-item v-if="$parametros_configuracion ['modvaltic']" :eager="true" transition="scroll-x-transition">
            <v-container class="mt-5 px-6">
              <div class="ml-3">
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="pervaltic" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="valticcodtarsag" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" ref="valticcodtarsag" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="4">
                    <CampoFormularioDatos nombre-campo="valticmaximpmen" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
                  </v-col>
                </v-row>
              </div>
            </v-container>
          </v-tab-item>

        </v-tabs-items>
        </div>
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from '@/components/CampoFormularioDatos.vue'
import api from '@/api'

export default {
  components: { TablaDatosAPI,
                CampoFormularioDatos },
  data() {
    return {
      tab: 0,
      tablasDatos: [],
      dc: {},
      rf: {},
      arrayTarifasSAGA: [],
    }
  },
  computed: {
    parametros_opeempinq() {
      return {
        idEmpresaInquilina: { valor: this.rf ['id_empinq'] ?? 0, descripcion: '' }
      };
    },
  },
  methods: {
    montadoTablaDatos (tablaDatos) {
      this.tablasDatos [tablaDatos.tabla] = tablaDatos;
    },
    antesAbrirFormularioDatos () {
      this.tab = 0;
      this.actualizarListaTarifasValidacionTickets();
    },
    async antesGuardarFormularioDatos (formulario, arrayCambiosEnRegistro) {
      let aux;

      // saneamos el array de MAXIMO DE PLAZAS por zona
      aux = {};
      Object.keys (this.rf.__maxplazon).forEach (clave => {
        let valor = this.rf.__maxplazon [clave];
        if (!this.procedeMostrarZona (clave))
          valor = null;
        if (!(isNaN (valor) || valor == "" || valor === null)) {
          aux[clave] = valor;
        }
      });
      if (JSON.stringify (aux) != JSON.stringify (this.rf.__maxplazon))
        arrayCambiosEnRegistro ['__maxplazon'] = aux;

      // saneamos el array de ASIGNACION DE PLAZAS por zona
      aux = {};
      Object.keys (this.rf.__asiplazon).forEach (clave => {
        let valor = this.rf.__asiplazon [clave];
        if (!this.procedeMostrarZona (clave))
          valor = null;
        if (!(valor == "" || valor === null)) {
          aux[clave] = valor;
        }
      });
      if (JSON.stringify (aux) != JSON.stringify (this.rf.__asiplazon))
        arrayCambiosEnRegistro ['__asiplazon'] = aux;

      // saneamos los datos de las modificaciones en "asignacion de plazas por zona"
      let asiplazon = arrayCambiosEnRegistro ['__asiplazon'];
      if (asiplazon) {
        Object.keys (asiplazon).forEach (clave => {
          let aux = asiplazon [clave];
          aux = aux.replace (/\s+/g, ""); // qutiamos espacios
          aux = aux.replace (/,+/g, ", "); // sustituimos las "," por ", "
          aux = aux.replace (/(^,)|(, $)/g, ""); // eliminamos las comas al principio y al final
          asiplazon [clave] = aux.toUpperCase(); // lo pasamos a mayusculas
        });
        arrayCambiosEnRegistro ['__asiplazon'] = asiplazon;
      }
      return true;
    },
    cambiosEnOperadores (datosRegistroEmpresaInquilina) {
      if (this.tablasDatos ['v_opeempinq'].hayCambiosModoMemoria())
        this.$set (datosRegistroEmpresaInquilina, 'cto__AUX', true); // cto = Cambios en Tabla de Operadores
      else
        this.$delete (datosRegistroEmpresaInquilina, 'cto__AUX');
    },
    despuesGuardarFormularioDatos () {
      api.loteCambiosRegistrosTablaVista ('v_opeempinq', this.tablasDatos ['v_opeempinq'].loteCambiosRegistros ((registro) => { registro.id_empinq = this.rf ['id_empinq'] }));
      this.$tablasConsulta.actualizar();
    },
    procedeMostrarZona (identificadorZona) {
      return this.$tablasConsulta.arrayRegistros ('r_zon_tippas').some (e => {
        if (e.id_zon == identificadorZona)
          if (this.rf.__listippas.includes (e.id_tippas))
            return true;
      });
    },
    filtradoItemsZonasSegunTiposDePases (item) {
      return this.procedeMostrarZona (item.value);
    },
    forzarValidacionCampos (){
      if (this.$refs['tablaEmpresasInquilinas'])
        this.$refs['tablaEmpresasInquilinas'].formulario.forzarValidacionCampos();
    },
    actualizarListaTarifasValidacionTickets () {
      this.dc ['valticcodtarsag'].dominio_valores = {};
      this.dc ['valticcodtarsag'].dominio_valores [null] = "(Tarifa del producto)";

      this.$sagabroker.solicitarListaTarifasAparcamiento (this.rf.id_ins)
        .then ((respuesta) => {
          respuesta.contenido.tarifas.forEach (tarifa => {
            this.dc ['valticcodtarsag'].dominio_valores [tarifa.codigo] = tarifa.descripcion;
          });
        })
        .finally (() => {
          if (this.$refs['valticcodtarsag'])
            this.$refs['valticcodtarsag'].actualizarItemsSelect();
        });
    }
  },
  mounted() {
    this.$tablasConsulta.actualizar();
  }
};
</script>

<style>
</style>